import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { prettyDate } from '@/helpers/date';
import { Checkbox } from '@/webkit/form/Checkbox';
import { FilterViewDesktop } from './desktop';
import s from './index.module.scss';

export const Filters = props => {
  const { params, setParams } = props;
  const { t } = useTranslation('activity');

  const onDateChange = range => {
    setParams(prev => ({ ...prev, page: 1, range }));
  };

  return (
    <div className={s.wrapper}>
      <FilterViewDesktop {...props} onDateChange={onDateChange} />
      <div className={s.footer}>
        <div className="f-small-regular">
          {t('portfolio_filters.portfolio_movements', {
            from: prettyDate(params.range[0], 'DD MMMM YYYY'),
            to: prettyDate(params.range[1], 'DD MMMM YYYY'),
          })}
        </div>
        <Checkbox
          name="grouping"
          checked={params.grouping}
          onChange={() =>
            setParams(prev => ({
              ...prev,
              page: 1,
              grouping: !params.grouping,
            }))
          }
        >
          <span className={classnames(s.grouping, 'f-small-regular')}>
            {t('portfolio_filters.group_by_round')}
          </span>
        </Checkbox>
      </div>
    </div>
  );
};
